import { Navigate, useLocation, useParams } from "react-router-dom";
import { Path } from "utils/constants/paths.constants";

export type TRedirectProps = {
  path: Path;
  preserveSearch?: boolean;
};

const Redirect = ({ path, preserveSearch = false }: TRedirectProps) => {
  const { search } = useLocation();
  const params = useParams();

  const to = Object.keys(params).reduce((to, paramKey) => {
    return to.replace(`:${paramKey}`, params[paramKey] ?? "");
  }, path);

  return <Navigate to={`${to}${preserveSearch ? search : ""}`} replace />;
};

export default Redirect;
